import type { PrioridadTarea, TareaPublic } from '@app/shared';

// ciclo-tareas-deadline (18/10/2026): el vencimiento es un día AAAA-MM-DD sin
// hora. Toda la cuenta se hace en UTC sobre la medianoche de ese día (igual que
// el backend, lib/horario.ts), así la zona del navegador no corre ninguna fecha.

// Mismo TZ que usa el backend para la semana ISO: "hoy" es el día de Argentina.
export const TZ_APP = 'America/Argentina/Buenos_Aires';

function diaUtc(fecha: string): Date {
  return new Date(`${fecha}T00:00:00Z`);
}

export function sumarDias(fecha: string, dias: number): string {
  const d = diaUtc(fecha);
  d.setUTCDate(d.getUTCDate() + dias);
  return d.toISOString().slice(0, 10);
}

/** Los 7 días (lunes a domingo) a partir del lunes `inicio`. */
export function diasDeSemana(inicio: string): string[] {
  return Array.from({ length: 7 }, (_, i) => sumarDias(inicio, i));
}

/** 0 = lunes ... 6 = domingo. */
export function diaIsoDeSemana(fecha: string): number {
  return (diaUtc(fecha).getUTCDay() + 6) % 7;
}

/** "22/10" */
export function diaMes(fecha: string): string {
  return `${fecha.slice(8, 10)}/${fecha.slice(5, 7)}`;
}

/** Índice 0-11 del mes de un día AAAA-MM-DD. */
export function indiceDeMes(fecha: string): number {
  return Number(fecha.slice(5, 7)) - 1;
}

/** El día de hoy (AAAA-MM-DD) en Argentina. */
export function hoy(ahora: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ_APP,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(ahora);
}

export function dentroDeSemana(fecha: string | null, inicio: string, fin: string): fecha is string {
  return fecha !== null && fecha >= inicio && fecha <= fin;
}

const PESO_PRIORIDAD: Record<PrioridadTarea, number> = { ALTA: 0, MEDIA: 1, BAJA: 2 };

/** De la más prioritaria a la menos; si empatan, el orden de la lista. */
export function porPrioridad(a: TareaPublic, b: TareaPublic): number {
  return PESO_PRIORIDAD[a.prioridad] - PESO_PRIORIDAD[b.prioridad] || a.orden - b.orden;
}
